<template>
  <div class="upload-csv-container">
    <Typography variant="h-2">Upload your CSV file</Typography>
    <CSVDragAndDrop
      :file="file"
      :columns="columns"
      @file-selected="$emit('file-changed', $event)"
    />
  </div>
</template>

<script>
import Typography from "@/components/generic/Typography";
import CSVDragAndDrop from "@/components/CSVDragAndDrop.vue";

export default {
  name: "UploadCSV",
  components: {
    Typography,
    CSVDragAndDrop,
  },
  props: {
    file: {
      type: File,
      default: undefined,
    },
    columns: {
      type: Array,
      default: () => [],
    },
  },
  emits: ["file-changed"],
};
</script>

<style scoped>
.upload-csv-container {
  padding-top: 2rem;
  display: flex;
  flex-direction: column;
  height: 100%;
  gap: 2rem;
}
</style>
